import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "toolbar" }
const _hoisted_2 = { class: "buttons" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "save-message" }
const _hoisted_5 = { key: 1 }

import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { qEditorState } from '../stores'
import { editorEventBus } from '../stores/eventBus'


export default /*@__PURE__*/_defineComponent({
  __name: 'ToolbarComponent',
  setup(__props) {

const notDisplay = ref(false)
const disableBtn = ref(false)
const sidebarChatVisible = ref(false)

const exam = computed(() => qEditorState.exam)
const hasError = computed(() => qEditorState.hasError)
const saveMessage = computed(() => qEditorState.saveMessage)
const isLoading = computed(() => qEditorState.isLoading)

const onSidebarChatChanged = (visible: boolean) => {
  sidebarChatVisible.value = visible
}

onMounted(() => {
  editorEventBus.on('sidebar-chat-changed', onSidebarChatChanged)
})

onBeforeUnmount(() => {
  editorEventBus.off('sidebar-chat-changed', onSidebarChatChanged)
})

const toggleAiChat = () => {
  editorEventBus.emit('toggle-ai-chat')
}

const onSave = () => {
  notDisplay.value = false
  disableBtn.value = true
  qEditorState.saveQuestions()
}

watch(isLoading, () => {
  if (saveMessage.value) {
    setTimeout(() => {
      notDisplay.value = true
      disableBtn.value = false
    }, 3000)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(['btn', 'btn-sm', 'btn-ai', { 'btn-ai--active': sidebarChatVisible.value }]),
        onClick: toggleAiChat,
        title: "AI Chat (⌘+Shift+L)"
      }, " AI ", 2 /* CLASS */),
      _createElementVNode("button", {
        type: "button",
        disabled: isLoading.value || disableBtn.value,
        class: "btn btn-sm btn-outline-success text-success",
        onClick: onSave,
        id: "qeditor-save"
      }, " 保存 ", 8 /* PROPS */, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!isLoading.value)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass({ 'text-success': !hasError.value, 'text-danger': hasError.value , 'hide-message': notDisplay.value})
          }, _toDisplayString(saveMessage.value), 3 /* TEXT, CLASS */))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "green"
            })
          ]))
    ])
  ]))
}
}

})